import EnvironmentManager from 'Utils/environmentManager';

export const MAX_TOTAL_ODD_DEFAULT = 12500000;

export default function getMaxTotalOdd () {
  return EnvironmentManager.getParameter('MAX_TOTAL_ODD') || MAX_TOTAL_ODD_DEFAULT;
}
